type FavoriteSortableQuery = {
  name?: string | null;
  createdOn?: string | number | Date | null;
  isFavourite?: boolean | number | null;
  isFavorite?: boolean | number | null;
};

export function sortQueriesByFavoriteAndName<T extends FavoriteSortableQuery>(queries: T[]): T[] {
  return [...queries].sort((leftQuery, rightQuery) => {
    const leftIsFavorite = Number(leftQuery?.isFavourite ?? leftQuery?.isFavorite ?? false);
    const rightIsFavorite = Number(rightQuery?.isFavourite ?? rightQuery?.isFavorite ?? false);

    if (leftIsFavorite !== rightIsFavorite) {
      return rightIsFavorite - leftIsFavorite;
    }

    if (leftIsFavorite === 1) {
      return (leftQuery.name ?? '').localeCompare(rightQuery.name ?? '', undefined, { sensitivity: 'base' });
    }

    const leftCreatedOn = new Date(leftQuery.createdOn ?? 0).getTime();
    const rightCreatedOn = new Date(rightQuery.createdOn ?? 0).getTime();

    if (leftCreatedOn !== rightCreatedOn) {
      return rightCreatedOn - leftCreatedOn;
    }

    return (leftQuery.name ?? '').localeCompare(rightQuery.name ?? '', undefined, { sensitivity: 'base' });
  });
}
